<template>
    <svg viewBox="0 0 85 97" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M66.6886 41.3762L55.9481 18.2953C55.4644 17.2535 54.4195 16.5869 53.2692 16.5869H17.7921C16.7038 16.5869 15.7023 17.1884 15.1876 18.1465L2.86272 41.1995C2.55266 41.7762 2.31702 42.387 2.14648 43.0133H19.113C21.147 43.0133 22.9019 44.4334 23.3298 46.4209L23.953 49.32C24.3189 51.0191 25.8227 52.2345 27.5621 52.2345H42.4233C44.0325 52.2345 45.4557 51.1927 45.9425 49.6579L47.0928 46.0271C47.6602 44.235 49.3252 43.0133 51.2073 43.0133L66.9087 42.8955C66.9087 42.8955 67.6095 44.821 67.3955 46.7279V72.0474C67.3955 72.9993 67.2405 73.9108 66.9584 74.7666C67.3087 73.824 67.5041 72.8039 67.5041 71.7404V45.0318C67.5041 43.7699 67.2281 42.5203 66.6948 41.3762H66.6886Z"
            fill="#E5EBFF"
        />
        <path
            d="M52.4735 13.998H23.2379C22.3526 13.998 21.6349 14.7157 21.6349 15.6011V28.9647C21.6349 29.85 22.3526 30.5677 23.2379 30.5677H52.4735C53.3588 30.5677 54.0765 29.85 54.0765 28.9647V15.6011C54.0765 14.7157 53.3588 13.998 52.4735 13.998Z"
            fill="white"
            stroke="#525252"
            stroke-width="1.24024"
            stroke-linejoin="round"
        />
        <path
            d="M52.3299 21.1758H17.4234C16.4593 21.1758 15.6777 21.9573 15.6777 22.9214V35.9998C15.6777 36.9638 16.4593 37.7454 17.4234 37.7454H52.3299C53.294 37.7454 54.0756 36.9638 54.0756 35.9998V22.9214C54.0756 21.9573 53.294 21.1758 52.3299 21.1758Z"
            fill="white"
            stroke="#525252"
            stroke-width="1.24024"
            stroke-linejoin="round"
        />
        <path
            d="M54.633 27.7891H15.1158C14.025 27.7891 13.1407 28.6733 13.1407 29.7641V44.5695C13.1407 45.6603 14.025 46.5446 15.1158 46.5446H54.633C55.7238 46.5446 56.6081 45.6603 56.6081 44.5695V29.7641C56.6081 28.6733 55.7238 27.7891 54.633 27.7891Z"
            fill="white"
            stroke="#525252"
            stroke-width="1.24024"
            stroke-linejoin="round"
        />
        <path
            d="M58.1162 33.4209H11.6351C10.3525 33.4209 9.31274 34.4607 9.31274 35.7433V53.1593C9.31274 54.4419 10.3525 55.4817 11.6351 55.4817H58.1162C59.3988 55.4817 60.4386 54.4419 60.4386 53.1593V35.7433C60.4386 34.4607 59.3988 33.4209 58.1162 33.4209Z"
            fill="white"
            stroke="#525252"
            stroke-width="1.24024"
            stroke-linejoin="round"
        />
        <path
            d="M2.03711 72.0015C2.03711 76.7888 5.91906 80.6676 10.7033 80.6676H59.0293C63.8166 80.6676 67.6954 76.7857 67.6954 72.0015V46.682C67.9094 44.7751 67.2086 42.8496 67.2086 42.8496L51.5072 42.9674C49.6251 42.9674 47.9601 44.186 47.3927 45.9812L46.2424 49.612C45.7556 51.1468 44.3324 52.1886 42.7232 52.1886H27.862C26.1226 52.1886 24.6188 50.9732 24.2529 49.2741L23.6297 46.375C23.2018 44.3875 21.4438 42.9674 19.4129 42.9674H2.43089C2.17044 43.7984 2.03711 44.6697 2.03711 45.5471V72.0015Z"
            fill="white"
        />
        <path
            d="M54.1378 16.3825C54.9378 16.6181 55.6168 17.1886 55.9796 17.97L66.72 41.0509C67.2534 42.195 67.5293 43.4445 67.5293 44.7065V71.415C67.5293 76.2024 63.6474 80.0812 58.8631 80.0812H10.5372C5.74982 80.0812 1.87097 76.1993 1.87097 71.415V44.9607C1.87097 43.5344 2.22134 42.1299 2.89417 40.8741L15.2191 17.8243C15.7338 16.8631 16.7353 16.2646 17.8236 16.2646H21.6559"
            stroke="#525252"
            stroke-width="1.24024"
            stroke-linejoin="round"
        />
        <path d="M45.5527 65.6035H62.5378" stroke="#C9D1EC" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        <path d="M45.5527 70.4541H57.6358" stroke="#C9D1EC" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        <path
            d="M2.19336 42.3809H19.2529C21.2869 42.3809 23.0418 43.8009 23.4697 45.7884L24.0929 48.6875C24.4588 50.3866 25.9626 51.602 27.702 51.602H42.5632C44.1724 51.602 45.5956 50.5602 46.0824 49.0254L47.2327 45.3946C47.8001 43.6025 49.4651 42.3809 51.3472 42.3809H63.4798"
            stroke="#525252"
            stroke-width="1.24024"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M57.9434 34.3895C66.6505 34.3895 73.709 27.331 73.709 18.624C73.709 9.91688 66.6505 2.8584 57.9434 2.8584C49.2363 2.8584 42.1779 9.91688 42.1779 18.624C42.1779 27.331 49.2363 34.3895 57.9434 34.3895Z"
            fill="#8C9FF8"
        />
        <path
            d="M57.0156 32.5311C65.7226 32.5311 72.7811 25.4726 72.7811 16.7656C72.7811 8.05848 65.7226 1 57.0156 1C48.3085 1 41.25 8.05848 41.25 16.7656C41.25 25.4726 48.3085 32.5311 57.0156 32.5311Z"
            stroke="#525252"
            stroke-width="1.86234"
            stroke-miterlimit="10"
        />
        <path
            d="M64.749 13.1542L61.9941 13.1689C61.0537 13.1726 60.286 12.4122 60.286 11.4719V8.94101C60.286 7.68109 59.2648 6.65625 58.0012 6.65625C57.4392 6.65625 56.9874 7.11173 56.9874 7.67007C56.9801 9.4222 57.3658 11.4425 56.385 13.0183C55.9112 13.7787 54.9745 14.2011 54.0966 14.2011C53.9129 14.2011 53.7366 14.1827 53.564 14.1497L53.5383 15.3582L53.4023 21.6284C53.4023 22.8406 54.3831 23.8213 55.5953 23.8213H63.6103C64.5506 23.8213 65.3588 23.1454 65.5204 22.2161L66.9125 15.5528C67.1403 14.2415 66.0787 13.0624 64.749 13.1542Z"
            fill="white"
        />
        <path
            d="M52.4195 13.0586H50.1421C49.5599 13.0586 49.0879 13.5306 49.0879 14.1128V23.4171C49.0879 23.9994 49.5599 24.4714 50.1421 24.4714H52.4195C53.0018 24.4714 53.4737 23.9994 53.4737 23.4171V14.1128C53.4737 13.5306 53.0018 13.0586 52.4195 13.0586Z"
            fill="white"
        />
        <path
            d="M52.4195 13.0586H50.1421C49.5599 13.0586 49.0879 13.5306 49.0879 14.1128V23.4171C49.0879 23.9994 49.5599 24.4714 50.1421 24.4714H52.4195C53.0018 24.4714 53.4737 23.9994 53.4737 23.4171V14.1128C53.4737 13.5306 53.0018 13.0586 52.4195 13.0586Z"
            stroke="#525252"
            stroke-width="1.10197"
            stroke-miterlimit="10"
        />
        <path
            d="M64.749 13.1542L61.9941 13.1689C61.0537 13.1726 60.286 12.4122 60.286 11.4719V8.94101C60.286 7.68109 59.2648 6.65625 58.0012 6.65625C57.4392 6.65625 56.9874 7.11173 56.9874 7.67007C56.9801 9.4222 57.3658 11.4425 56.385 13.0183C55.9112 13.7787 54.9745 14.2011 54.0966 14.2011C53.9129 14.2011 53.7366 14.1827 53.564 14.1497L53.5383 15.3582L53.4023 21.6284C53.4023 22.8406 54.3831 23.8213 55.5953 23.8213H63.6103C64.5506 23.8213 65.3588 23.1454 65.5204 22.2161L66.9125 15.5528C67.1403 14.2415 66.0787 13.0624 64.749 13.1542Z"
            stroke="#525252"
            stroke-width="1.18469"
            stroke-miterlimit="10"
            stroke-linecap="round"
        />
    </svg>
</template>
